<template>
  <div>
    <div id="ding-login"></div>
    <el-button @click="dingLogin">钉钉登录</el-button>
    <el-button @click="dingLogin">微信登录</el-button>
    <el-button @click="dingLogin">QQ 登录</el-button>
  </div>
</template>

<script>
  import qs from 'qs'
  export default {
    name: "Login",
    data () {
      return {
        ding: {
          appId: '', // 授权id
          appSecret: '',
          code: '',
          uri: '',
          redirect_url: 'http://www.vaiwan.com/iot/getUserInfoByCode' //设置重定向地址
        },
        http_url: ''
      }
    },
    created() {
      this.getAppInfo();
    },
    methods: {
      // 获取AppId和AppSecret
      getAppInfo() {
      axios.get('http://localhost:2048/iot/unified/dingtalk/getAppInfo').then(res => {
          if (res.data.code === 200) {
            this.ding.appId = res.data.data.appId;
            this.ding.appSecret = res.data.data.appSecret;
          } else {
            this.message({type: 'error', message: '获取AppId和AppSecret失败！'});
          }
        });
      },

      // 切换钉钉登录
      dingLogin() {
        // 获取到钉钉APP相关信息
        // this.getAppInfo();
        // 钉钉扫码触发事件
        let obj = DDLogin({
          id: 'ding-login',
          // goto这里需要对url整体做一个urlencode编码
          goto: encodeURIComponent('https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=' + this.ding.appId + '&response_type=code&scope=snsapi_login&state=STATE&redirect_uri=' + this.ding.redirect_url + ''),
          style: 'border:none;background-color:#FFFFFF;',
          width: '365',
          height: '300'
        });

        // 获取临时登录码
        let hanndleMessage = function(event) {
          let origin = event.origin;
          console.log(origin)
          // 判断是否来自ddLogin扫码事件
          if (origin === 'https://login.dingtalk.com') {
            let loginTmpCode = event.data;
            let appId = 'dingoavrh9cwin1itkjspf';
            let redirectUrl = 'http://www.vaiwan.com/iot/getUserInfoByCode';
            console.log("===二维码：" + loginTmpCode)
            //console.log("===APP_ID: " + this.ding.appId)
            // 这里url不用进行urlencode编码
            let url = 'https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=' + appId +
              '&response_type=code&scope=snsapi_login&state=STATE&redirect_uri=' + redirectUrl +
              '&loginTmpCode=' + loginTmpCode;
            window.location.href = url
            // this.getUserIdByCode(loginTmpCode);
          } else {
            console.log("===>不是来自钉钉扫码登录事件")
          }
        };
        // 钉钉扫码监听
        if (typeof window.addEventListener !== 'undefined') {
          console.log("===>【1】")
          window.addEventListener('message', hanndleMessage, false)
        } else if (typeof window.attachEvent !== 'undefined') {
          console.log("===>【2】")
          window.attachEvent('onmessage', hanndleMessage)
        }
      },

      // 根据临时授权码获取userId
      getUserIdByCode(code) {
        axios.get('http://localhost:2048/iot/unified/getUserInfoByCode/' + code).then(res => {
          if (res.data.code === 200) {
            console.log(res)

          } else {
            this.message({type: 'error', message: '根据临时授权码获取userId失败！'});
          }
        });
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/pageview/Login.vue